import {get} from 'lodash';
import {GET_WIDGET} from './constants';
import {DATA, LOADING} from '../constants';

export const widgetSelector = (state) => get(state, [GET_WIDGET, DATA]);

export const isWidgetDataLoadingSelector = (state) =>
    get(state, [GET_WIDGET, LOADING]);
